import "./LandingPage.css";
import React, { useState } from "react";
import { Container } from "react-bootstrap";
import SidemenuPage from "../../sidemenu/components/SidemenuPage";
import { Outlet } from "react-router-dom";
import chevron_right from "../../../../assets/chevron_right.svg";

export default function LandingPage() {
  const [showSidenav, setShowsidenav] = useState(false);

  const showSidenavbar = () => {
    setShowsidenav(true);
  };

  return (
    <div className="user-landing">
      <div id={"Main-content"}>
        <Container className="main-container">
          {/* Mobile side bar icon */}
          <button
            className="sidemenu_icon btn-submit"
            style={{ display: showSidenav ? "none" : "" }}
            onClick={() => showSidenavbar()}
          >
            <img src={chevron_right} alt="next"></img>
          </button>
          <div className="card " id={"user-card"}>
            <div className="card-body" id={"card-body"}>
              <SidemenuPage
                showSidenav={showSidenav}
                setShowsidenav={setShowsidenav}
              />
              <div
                className={`col-xl-9 menu-contents ${showSidenav && "show"}`}
              >
                <Outlet />
              </div>
            </div>
          </div>
        </Container>
      </div>

    </div>
  );
}
